import { faSpinnerThird as fasSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';

import { Icon, IconProps } from '@growtherapy/sprout-ui';

type LoadingSpinnerProps =
  | (Omit<IconProps, 'name' | 'variant'> & {
      'aria-label': string;
      'aria-hidden': false;
    })
  | {
      'aria-label'?: never;
      'aria-hidden'?: true;
    };

export function LoadingSpinner(passThroughProps: LoadingSpinnerProps) {
  return <Icon className='text-neutral-900 fa-spin' icon={fasSpinnerThird} {...passThroughProps} />;
}
